import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import styles from './ChoosePackagePage.module.scss';
import ServicePackages from "../../../components/ServicePackages/ServicePackages";
import SwiperServicePackages from "../../../components/SwiperServicePackages/SwiperServicePackages";
import {stepperInfoActions} from "../../../store/slices/stepperInfoSlice";
import {MAIN_ROUTES} from "../../../routing/main_routes";

const ChoosePackagePage = ({setCurrentStep}) => {
    const dispatch = useDispatch();

    const currentStep = JSON.parse(localStorage.getItem('currentStep'));
    const navigate = useNavigate();

    useEffect(() => {
        if (currentStep !== 2) {
            navigate(MAIN_ROUTES.CREATE_ORDER);
        }
    }, []);

    const {servicePackages, status} = useSelector(state => state.servicePackages);
    const {service_package} = useSelector(state => state.stepperInfo);

    // Guard against an undefined/empty packages list so children never read
    // `.length` of undefined.
    const safeServicePackages = Array.isArray(servicePackages) ? servicePackages : [];

    const [sortedServicePackages, setSortedServicePackages] = useState([]);
    const [customPackage, setCustomPackage] = useState({});

    useEffect(() => {
        // sorting array of service packages by id
        if (safeServicePackages.length > 0) {
            const sortedServicePackagesById = [...safeServicePackages]?.sort((a, b) => a.id - b.id);
            setSortedServicePackages(sortedServicePackagesById);

            //set default package
            if (!service_package?.name) {
                const {id, name, price, service_list} = sortedServicePackagesById[0];
                if (service_list) {
                    dispatch(stepperInfoActions.setServicePackage({
                        id,
                        name,
                        price: +price,
                        services: service_list.toString().split(', ')
                    }));
                } else {
                    dispatch(stepperInfoActions.setServicePackage({
                        id,
                        name,
                        price: +price,
                        services: []
                    }));
                }
            }

            setCustomPackage(sortedServicePackagesById[sortedServicePackagesById.length - 1]);
        }
    }, [servicePackages]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, []);

    return (
        <div className={styles.choosePackagePage_wrapper}>
            <div className={styles.choosePackagePage_wrapper_choosePackage}>
                <p className={styles.choosePackagePage_wrapper_choosePackage_subtitle}>Оберіть пакет послуг <sup>*</sup>
                </p>

                {sortedServicePackages.length === 0 ? (
                    <p className={styles.choosePackagePage_wrapper_choosePackage_subtitle}>
                        {status === 'loading'
                            ? 'Завантаження пакетів послуг...'
                            : 'Пакети послуг тимчасово недоступні. Спробуйте, будь ласка, пізніше.'}
                    </p>
                ) : (
                    <>
                        <div className={styles.choosePackagePage_wrapper_choosePackage_desktop}>
                            <ServicePackages servicePackages={sortedServicePackages} customPackage={customPackage}/>
                        </div>
                        <div className={styles.choosePackagePage_wrapper_choosePackage_mobile}>
                            <SwiperServicePackages services={sortedServicePackages} customPackage={customPackage}/>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ChoosePackagePage;
